module.exports = __webpack_public_path__ + "img/FHY.3a083e9c.png";